import React from "react";
import { useAuthDataContext } from "../../components/auth-provider";
import { Button, TextField, Typography } from "@material-ui/core";
import { useStyles } from "./LoginPage";


export const ForgotPassForm = (props: { onOk: () => void; }) => {

  const classes = useStyles();

  const { onForgotPassword, isLoading } = useAuthDataContext();

  const onFinish = async (ev: any) => {

    ev.preventDefault();

    const { email } = ev.currentTarget.elements;

    var values = {
      email: email.value,
    };

    if (onForgotPassword) {
      var ok = await onForgotPassword(values.email);
      if (ok && props.onOk) {
        props.onOk();
      }

    }
  };

  return (
    <>
      <Typography component="h3" variant="h5">
        Redefinição de Senha
      </Typography>

      <p style={{ padding: '16px' }}>Uma mensagem com um link será enviada para o email informado</p>

      <form className={classes.form} noValidate onSubmit={onFinish}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="E-mail"
          name="email"
          autoComplete="email"
          autoFocus />

        {isLoading === false && <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          Redefinir Senha
          </Button>}

      </form>
    </>
  );
};
